import { ElementType, lazy } from "react";
// TODO: Add lazy loading of each page element when development is complete

import HomePage from "../pages/web/Home/Home";
import PricingPage from "../pages/web/pricing/Pricing";
import PrivacyPolicyPage from "../pages/web/privacyPolicy/PrivacyPolicy";
import ProductDetailsPage from "../pages/web/ProductDetails/ProductDetails";
import StoriesPage from "../pages/web/stories/Stories";
import StoriesDetailsPage from "../pages/web/storiesDetails/StoriesDetails";

import BusinessUnitMatrixList from "../pages/admin/ApprovalMatrix/BusinessUnit/BusinessUnitMatrixList";
import ManageBusinessUnitMatrix from "../pages/admin/ApprovalMatrix/BusinessUnit/ManageBusinessUnitMatrix";
import ApprovalDepartmentList from "../pages/admin/ApprovalMatrix/Department/DepartmentMatrixList";
import ManageDepartmentMatrix from "../pages/admin/ApprovalMatrix/Department/ManageDepartmentMatrix";
import AccountDeactivated from "../pages/admin/AccountDeactivated/AccountDeactivated";
import AddNewBusiness from "../pages/admin/Businesses/AddNewBusiness";
import AddNewRequests from "../pages/admin/Businesses/AddNewRequests";
import BusinessList from "../pages/admin/Businesses/BusinessList";
import HolidayCalender from "../pages/admin/Businesses/HolidayCalender";
import BusinessListDetails from "../pages/admin/Businesses/BusinessListDetails";
import BusinessPackageDetails from "../pages/admin/Businesses/BusinessPackageDetails";
import BusinessProductAssign from "../pages/admin/Businesses/BusinessProductAssign";
import BusinessUserCreate from "../pages/admin/Businesses/BusinessUserCreate";
import RequestsList from "../pages/admin/Businesses/RequestsList";
import RequestsListDetails from "../pages/admin/Businesses/RequestsListDetails";
import RequestsPackageDetails from "../pages/admin/Businesses/RequestsPackageDetails";
import CustomerDetails from "../pages/admin/Customers/CustomerDetails";
import Customers from "../pages/admin/Customers/Customers";
import DashboardV3 from "../pages/admin/Dashboard/DashboardV3";
import DepartmentList from "../pages/admin/Department/DepartmentList";
import Disbursement from "../pages/admin/Disbursement/Disbursement";
import DisbursementBatchList from "../pages/admin/Disbursement/DisbursementBatchList";
import DisbursementDetails from "../pages/admin/Disbursement/DisbursementDetails";
import EditEmployees from "../pages/admin/Employee/EditEmployees";
import Employees from "../pages/admin/Employee/Employees";
import EmployeesDetails from "../pages/admin/Employee/EmployeesDetails";
import Feedback from "../pages/admin/Feedback/Feedback";
import Footer from "../pages/admin/Footer/Footer";
import Header from "../pages/admin/Header/Header";
import Home from "../pages/admin/Home/Home";
import BusinessUnits from "../pages/admin/Org-Setting/BusinessUnits";
import Department from "../pages/admin/Org-Setting/Department";
import Designation from "../pages/admin/Org-Setting/Designation";
import WorkStation from "../pages/admin/Org-Setting/WorkStation";
import Packages from "../pages/admin/Package/Packages";
import Payment from "../pages/admin/Payment/Payment";
import PayrollBatchList from "../pages/admin/PayrollDisbursement/PayrollBatchList";
import PayrollDisbursement from "../pages/admin/PayrollDisbursement/PayrollDisbursement";
import PayrollDisbursementDetails from "../pages/admin/PayrollDisbursement/PayrollDisbursementDetails";
import PricingFaq from "../pages/admin/PricingFaq/PricingFaq";
import PrivacyPolicy from "../pages/admin/PrivacyPolicy/PrivacyPolicy";
import AddEditProduct from "../pages/admin/Products/AddEditProduct";
import ProductCategories from "../pages/admin/Products/ProductCategories";
import ProductClient from "../pages/admin/Products/ProductClient";
import Products from "../pages/admin/Products/Products";
import AddNewBatch from "../pages/admin/SalaryDisbursement/Batch/AddNewBatch";
import BatchManagement from "../pages/admin/SalaryDisbursement/Batch/BatchManagement";
import BatchPendingList from "../pages/admin/SalaryDisbursement/Batch/BatchPendingList";
import History from "../pages/admin/SalaryDisbursement/History/History";
import HistoryDetails from "../pages/admin/SalaryDisbursement/History/HistoryDetails";
import PaymentDetails from "../pages/admin/SalaryDisbursement/Payments/PaymentDetails";
import PaymentsV2 from "../pages/admin/SalaryDisbursement/Payments/PaymentsV2";
import ChangePassword from "../pages/admin/Settings/ChangePassword";
import Settings from "../pages/admin/Settings/Settings";
import UserPoolAssignList from "../pages/admin/ShebaPayWallet/PermissionAssign/UserPoolAssignList";
import UserRoleAssignList from "../pages/admin/ShebaPayWallet/PermissionAssign/UserRoleAssignList";
import ShebaFintechMerchant from "../pages/admin/ShebaPayWallet/ShebaFintechMerchant";
import ShebaFintechPin from "../pages/admin/ShebaPayWallet/ShebaFintechPin";
import ShebaFintechSuccess from "../pages/admin/ShebaPayWallet/ShebaFintechSuccess";
import ShebaFintechVerification from "../pages/admin/ShebaPayWallet/ShebaFintechVerification";
import ShebaPayWallet from "../pages/admin/ShebaPayWallet/ShebaPayWallet";
import TransactionHistory from "../pages/admin/ShebaPayWallet/TransactionHistory";
import WalletTagsList from "../pages/admin/ShebaPayWallet/WalletTags/WalletTagsList";
import Statements from "../pages/admin/Statements/Statements";
import Stories from "../pages/admin/Stories/Stories";
import SubDepartmentList from "../pages/admin/SubDepartment/SubDepartmentList";
import UserGroupPermission from "../pages/admin/UserAccessPermission/UserGroup/UserGroup";
import UserGroupCreate from "../pages/admin/UserAccessPermission/UserGroup/UserGroupCreate";
import UserAddPermission from "../pages/admin/UserAccessPermission/Users/UserAddPermission";
import UserBulkPermission from "../pages/admin/UserAccessPermission/Users/UserBulkPermission";
import UserDetailsPermission from "../pages/admin/UserAccessPermission/Users/UserDetailsPermission";
import UserEditPermission from "../pages/admin/UserAccessPermission/Users/UserEditPermission";
import UserListPermission from "../pages/admin/UserAccessPermission/Users/UserListPermission";
import ApprovalDaynamicList from "../pages/admin/Users/ApprovalDynamic/ApprovalDaynamicList";
import ApprovalDynamic from "../pages/admin/Users/ApprovalDynamic/ApprovalDynamic";
import AddAssignProduct from "../pages/admin/Users/RoleAccess/AddAssignProduct";
import AddAssignRole from "../pages/admin/Users/RoleAccess/AddAssignRole";
import RoleAccessList from "../pages/admin/Users/RoleAccess/RoleAccessList";
import RoleBaseProductList from "../pages/admin/Users/RoleAccess/RoleBaseProductList";
import RoleCreate from "../pages/admin/Users/RoleCreate/RoleCreate";
import AddEditUserGroup from "../pages/admin/Users/UserGroup/AddEditUserGroup";
import UserGroup from "../pages/admin/Users/UserGroup/UserGroup";
import UserGroupDetails from "../pages/admin/Users/UserGroup/UserGroupDetails";
import AddEditNewRoll from "../pages/admin/Users/UsersList/AddEditNewRoll";
import AddEditNewUser from "../pages/admin/Users/UsersList/AddEditNewUser";
import UserDetails from "../pages/admin/Users/UsersList/UserDetails";
import UserPermission from "../pages/admin/Users/UsersList/UserPermission";
import UsersList from "../pages/admin/Users/UsersList/UsersList";
import BatchVendorV2 from "../pages/admin/VendorPayment/Batch/BatchVendorV2";
import PaymentsVendorV2 from "../pages/admin/VendorPayment/Payments/PaymentsVendorV2";
import KeycloakLogin from "../pages/auth/KeycloakLogin";
import BsrmDashboard from "../pages/bsrm/BsrmDashboard/BsrmDashboard";
import DealerList from "../pages/bsrm/DealerList/DealerList";
import RetailerList from "../pages/bsrm/RetailerList/RetailerList";
import Statement from "../pages/bsrm/Statement/Statement";
import TraderList from "../pages/bsrm/TraderList/TraderList";
import BankTransactionList from "../pages/cashCollection/BankTransections/BankTransactionList";
import AddEditCollectionPoint from "../pages/cashCollection/CollectionPoint/BusinessPoints/AddEditCollectionPoint";
import BusinessPointsList from "../pages/cashCollection/CollectionPoint/BusinessPoints/BusinessPointsList";
import IndividualPointList from "../pages/cashCollection/CollectionPoint/IndividualPoints/IndividualPointList";
import Dashboard from "../pages/cashCollection/Dashboard/Dashboard";
import FieldOfficersDetails from "../pages/cashCollection/FieldOfficers/FieldOfficersDetails";
import FieldOfficersList from "../pages/cashCollection/FieldOfficers/FieldOfficersList";
import AreaList from "../pages/cashCollection/TerritoryManagement/Area/AreaList";
import RouteList from "../pages/cashCollection/TerritoryManagement/Route/RouteList";
import TerritoryList from "../pages/cashCollection/TerritoryManagement/Territory/TerritoryList";
import ZoneList from "../pages/cashCollection/TerritoryManagement/Zone/ZoneList";
import TransactionDetails from "../pages/cashCollection/Transactions/TransactionDetails";
import TransactionList from "../pages/cashCollection/Transactions/TransactionList";
import { Role } from "../types/common";

const AddStories = lazy(() => import("../components/AddStories/AddStories"));
// const AddUser = lazy(() => import("../components/AddUser/AddUser"));
// const CustomerDetails = lazy(
//   () => import("../pages/admin/Customers/CustomerDetails")
// );
// const Customers = lazy(() => import("../pages/admin/Customers/Customers"));
// const Dashboard = lazy(() => import("../pages/admin/Dashboard/Dashboard"));
// const Feedback = lazy(() => import("../pages/admin/Feedback/Feedback"));
// const Footer = lazy(() => import("../pages/admin/Footer/Footer"));
// const Header = lazy(() => import("../pages/admin/Header/Header"));
// const Home = lazy(() => import("../pages/admin/Home/Home"));
// const Packages = lazy(() => import("../pages/admin/Package/Packages"));
// const Payment = lazy(() => import("../pages/admin/Payment/Payment"));
// const PricingFaq = lazy(() => import("../pages/admin/PricingFaq/PricingFaq"));
// const PrivacyPolicy = lazy(
//   () => import("../pages/admin/PrivacyPolicy/PrivacyPolicy")
// );
// const Products = lazy(() => import("../pages/admin/Products/Products"));
// const Stories = lazy(() => import("../pages/admin/Stories/Stories"));

// const UsersList = lazy(
//   () => import("../pages/admin/Users/UsersList/UsersList")
// );
// const RoleCreate = lazy(
//   () => import("../pages/admin/Users/RoleCreate/RoleCreate")
// );
const NotFound = lazy(() => import("../pages/NotFound"));
const SignIn = lazy(() => import("../pages/auth/SignIn"));
const SignUp = lazy(() => import("../pages/auth/SignUp"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const VerifyAccount = lazy(() => import("../pages/auth/VerifyAccount"));

export interface RouteType {
  path: string;
  element: ElementType;
  roles: Role[];
  name?: string;
}

// auth routers
export const sidebarRouters: RouteType[] = [
  {
    path: "/admin/account-deactivated",
    element: AccountDeactivated,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/dashboard",
    element: DashboardV3,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list",
    element: BusinessList,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/holiday-calender",
    element: HolidayCalender,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/add-new",
    element: AddNewBusiness,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/edit/:id",
    element: AddNewBusiness,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/product-assign/:id",
    element: BusinessProductAssign,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/product-assign/edit/:id",
    element: BusinessProductAssign,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/package-details",
    element: BusinessPackageDetails,
    roles: ["Admin", "all", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/:id",
    element: BusinessListDetails,
    roles: ["Admin", "all", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/:id/user-create",
    element: BusinessUserCreate,
    roles: ["Admin", "all", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/business-list/:id/details/:viewId",
    element: BusinessUserCreate,
    roles: ["Admin", "all", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/requests",
    element: RequestsList,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/requests-list/:id",
    element: RequestsListDetails,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/requests-list/package-details",
    element: RequestsPackageDetails,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/businesses/requests-list/add-new",
    element: AddNewRequests,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/customers",
    element: Customers,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/customers/view/:viewId",
    element: CustomerDetails,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/payment",
    element: Payment,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/packages",
    element: Packages,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  // ===============
  // Products
  // ===============
  {
    path: "/admin/products/product",
    element: ProductClient,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/products/product-list",
    element: Products,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/products/product-list/add-product",
    element: AddEditProduct,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/products/product-list/edit-product/:id",
    element: AddEditProduct,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/products/product-categories",
    element: ProductCategories,
    roles: ["Admin", "SUPER_ADMIN"],
  },

  // ===============
  //Vendor Payment
  //================
  {
    path: "/admin/vendor-payment/batch",
    element: BatchVendorV2,
    roles: ["Admin", "checker", "maker", "approver"],
  },
  {
    path: "/admin/vendor-payment/batch/payments/:id",
    element: PaymentsVendorV2,
    roles: ["Admin", "checker", "maker", "approver"],
  },

  // ===============
  //Salary Disbursement
  //================
  //   {
  //   path: "/admin/salary-disbursement/batch",
  //   element: Batch,
  //   roles: ["Admin", "SUPER_ADMIN"],
  // },
  // {
  //   path: "/admin/salary-disbursement/batch",
  //   element: WalletList,
  //   roles: ["Admin", "checker", "maker", "approver", "user"],
  // },
  // {
  //   path: "/admin/salary-disbursement/batch/batch-list/:walletId",
  //   element: BatchV2,
  //   roles: ["Admin", "checker", "maker", "approver", "user"],
  // },
  {
    path: "/admin/salary-disbursement/batch",
    element: BatchManagement,
    roles: ["Admin", "checker", "maker", "approver", "user"],
  },

  {
    path: "/admin/salary-disbursement/batch/pending-list/:id",
    element: BatchPendingList,
    roles: ["Admin", "SUPER_ADMIN", "maker", "user"],
  },
  {
    path: "/admin/salary-disbursement/batch/batch-add",
    element: AddNewBatch,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  // {
  //   path: "/admin/salary-disbursement/batch/payments/:id",
  //   element: Payments,
  //   roles: ["Admin", "SUPER_ADMIN"],
  // },
  {
    path: "/admin/salary-disbursement/batch/payments/:id/:walletId",
    element: PaymentsV2,
    roles: ["Admin", "checker", "maker", "approver"],
  },
  {
    path: "/admin/salary-disbursement/batch/payments-details/:id",
    element: PaymentDetails,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/salary-disbursement/history",
    element: History,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/salary-disbursement/history/history-details/:id",
    element: HistoryDetails,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/salary-disbursement/statements",
    element: Statements,
    roles: ["Admin", "checker", "maker", "approver", "user"],
  },

  // ===============
  // Users and Roles
  // ===============
  {
    path: "/admin/users-roll-access/user-list",
    element: UsersList,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-list/user-permission/:id/:name",
    element: UserPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-list/user-details/:id",
    element: UserDetails,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-list/edit/:id",
    element: AddEditNewUser,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-list/user-add",
    element: AddEditNewUser,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-list/roll-add",
    element: AddEditNewRoll,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/create-role",
    element: RoleCreate,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/approval-dynamic-list",
    element: ApprovalDaynamicList,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/approval-dynamic-add",
    element: ApprovalDynamic,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/approval-dynamic-edit/:id",
    element: ApprovalDynamic,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-group",
    element: UserGroup,
    roles: ["Admin", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-group/add",
    element: AddEditUserGroup,
    roles: ["Admin", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-group/edit/:id",
    element: AddEditUserGroup,
    roles: ["Admin", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/user-group/details/:id",
    element: UserGroupDetails,
    roles: ["Admin", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  // Role Access V 2
  {
    path: "/admin/users-roll-access/roll-access",
    element: RoleAccessList,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/roll-access/add",
    element: AddAssignProduct,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/roll-access/product-access/:companyId/:projectId/:projectName/:serviceName",
    element: RoleBaseProductList,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/users-roll-access/roll-access/product-access/:companyId/:projectId/:projectName/:serviceName/add",
    element: AddAssignRole,
    roles: ["Admin", "SUPER_ADMIN"],
  },

  // ================
  // Approval Matrix
  // ================
  {
    path: "/admin/approval-matrix/vendor-management",
    element: BusinessUnitMatrixList,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/add",
    element: ManageBusinessUnitMatrix,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/edit/:id",
    element: ManageBusinessUnitMatrix,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/view/:id",
    element: ManageBusinessUnitMatrix,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/department",
    element: ApprovalDepartmentList,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/department/add",
    element: ManageDepartmentMatrix,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/department/edit/:id",
    element: ManageDepartmentMatrix,
    roles: ["Admin"],
  },
  {
    path: "/admin/approval-matrix/vendor-management/department/view/:id",
    element: ManageDepartmentMatrix,
    roles: ["Admin"],
  },

  // ================
  // Department
  // ================
  {
    path: "/admin/settings",
    element: DepartmentList,
    roles: ["Admin"],
  },
  {
    path: "/admin/org-settings/business-units",
    element: BusinessUnits,
    roles: ["Admin", "HR_ADMIN"],
  },
  {
    path: "/admin/org-settings/work-stations",
    element: WorkStation,
    roles: ["Admin", "HR_ADMIN"],
  },
  {
    path: "/admin/org-settings/departments",
    element: Department,
    roles: ["Admin", "HR_ADMIN"],
  },
  {
    path: "/admin/org-settings/designations",
    element: Designation,
    roles: ["Admin", "HR_ADMIN"],
  },
  {
    path: "/admin/employees",
    element: Employees,
    roles: ["Admin", "HR_ADMIN", "SUPER_ADMIN"],
  },
  {
    path: "/admin/employees/view/:viewId",
    element: EmployeesDetails,
    roles: ["Admin", "HR_ADMIN", "SUPER_ADMIN"],
  },

  {
    path: "/admin/employees/edit/:editId",
    element: EditEmployees,
    roles: ["Admin", "HR_ADMIN", "SUPER_ADMIN"],
  },

  // ================
  // Sub Department
  // ================
  {
    path: "/admin/settings/sub-department",
    element: SubDepartmentList,
    roles: ["Admin"],
  },

  {
    path: "/admin/sheba-pay-wallet",
    element: ShebaPayWallet,
    roles: ["Admin", "all", "checker", "maker", "approver"],
  },
  {
    path: "/admin/sheba-pay-wallet/user-role-assign/:id",
    element: UserRoleAssignList,
    roles: ["Admin", "all", "checker", "maker", "approver"],
  },
  {
    path: "/admin/sheba-pay-wallet/user-pool-assign/:id",
    element: UserPoolAssignList,
    roles: ["Admin", "all", "checker", "maker", "approver"],
  },
  {
    path: "/admin/sheba-pay-wallet/wallet-tags",
    element: WalletTagsList,
    roles: ["Admin", "all", "checker", "maker", "approver"],
  },
  {
    path: "/admin/sheba-pay-wallet/sheba-fintech/merchant",
    element: ShebaFintechMerchant,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/sheba-fintech/verification",
    element: ShebaFintechVerification,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/sheba-fintech/pin",
    element: ShebaFintechPin,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/sheba-fintech/success",
    element: ShebaFintechSuccess,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/transaction-history",
    element: TransactionHistory,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/payroll-disbursement",
    element: PayrollBatchList,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/payroll-disbursement/batch-code/:id",
    element: PayrollDisbursement,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/payroll-disbursement-details/:id",
    element: PayrollDisbursementDetails,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/disbursement",
    element: DisbursementBatchList,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/disbursement/batch-code/:id",
    element: Disbursement,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/sheba-pay-wallet/disbursement-details",
    element: DisbursementDetails,
    roles: ["Admin", "all", "checker", "maker", "approver", "SUPER_ADMIN"],
  },
  {
    path: "/admin/feedback",
    element: Feedback,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/header",
    element: Header,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/footer",
    element: Footer,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/home",
    element: Home,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/stories",
    element: Stories,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/stories/add-stories",
    element: AddStories,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/privacy-policy",
    element: PrivacyPolicy,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/pricing-faq",
    element: PricingFaq,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-info",
    element: Settings,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/change-password",
    element: ChangePassword,
    roles: ["Admin", "SUPER_ADMIN"],
  },

  // ===============
  // BSRM Dashboard
  // ===============
  {
    path: "/admin/bsrm/dashboard",
    element: BsrmDashboard,
    roles: ["Admin"],
  },
  {
    path: "/admin/bsrm/statement",
    element: Statement,
    roles: ["Admin"],
  },
  {
    path: "/admin/bsrm/dealer-list",
    element: DealerList,
    roles: ["Admin"],
  },
  {
    path: "/admin/bsrm/trader-list",
    element: TraderList,
    roles: ["Admin"],
  },
  {
    path: "/admin/bsrm/retailer-list",
    element: RetailerList,
    roles: ["Admin"],
  },

  // ===============
  // Cash Collection
  // ===============
  {
    path: "/admin/cash-dashboard",
    element: Dashboard,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-transactions",
    element: TransactionList,
    roles: ["Admin"],
  },
  {
    path: "/admin/bank-transactions",
    element: BankTransactionList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-transactions/details/:srId/:id",
    element: TransactionDetails,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-collection-point",
    element: BusinessPointsList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-collection-point/add",
    element: AddEditCollectionPoint,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-collection-point/edit/:id",
    element: AddEditCollectionPoint,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-collection-point/individual",
    element: IndividualPointList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-field-officers",
    element: FieldOfficersList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-field-officers/details/:userId",
    element: FieldOfficersDetails,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-territory-management/zone",
    element: ZoneList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-territory-management/area",
    element: AreaList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-territory-management/territory",
    element: TerritoryList,
    roles: ["Admin"],
  },
  {
    path: "/admin/cash-territory-management/route",
    element: RouteList,
    roles: ["Admin"],
  },
  // user access
  {
    path: "/admin/user-access-permission/user-list",
    element: UserListPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-list/add",
    element: UserAddPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-list/bulk",
    element: UserBulkPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-list/edit/:id",
    element: UserEditPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-list/view/:id",
    element: UserDetailsPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-group",
    element: UserGroupPermission,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-group/create",
    element: UserGroupCreate,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-group/update/:updatedId",
    element: UserGroupCreate,
    roles: ["Admin", "SUPER_ADMIN"],
  },
  {
    path: "/admin/user-access-permission/user-group/view/:viewId",
    element: UserGroupCreate,
    roles: ["Admin", "SUPER_ADMIN"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  {
    path: "/",
    element: HomePage,
  },
  {
    path: "/product-details",
    element: ProductDetailsPage,
  },
  {
    path: "/pricing",
    element: PricingPage,
  },
  {
    path: "/stories",
    element: StoriesPage,
  },
  {
    path: "/stories/:id",
    element: StoriesDetailsPage,
  },
  {
    path: "/privacy-policy",
    element: PrivacyPolicyPage,
  },
  {
    path: "/sign-in",
    element: KeycloakLogin,
  },
  {
    path: "/sign-up",
    element: SignUp,
  },
  {
    path: "/forgot-password",
    element: ForgotPassword,
  },
  {
    path: "/reset-password",
    element: ResetPassword,
  },
  {
    path: "/verify-account",
    element: VerifyAccount,
  },
  {
    path: "*",
    element: NotFound,
  },
];
